import { create } from 'zustand';
import { auth } from '@/shared/lib';
import fetchMeService from '../api/services/fetchMe';

interface UserStore {
  me: any;
  fetchMe: () => Promise<void>;
  // Ports AppFlowActions.SET_ME_DATA — the reducer case has no live dispatcher
  // anywhere in the app (grep confirms 0 callers outside its own tests), kept
  // as-is per the migration's port-dead-code-verbatim rule.
  setMeData: (data: any) => void;
  reset: () => void;
}

const defaultState = { me: {} };

const useUserStore = create<UserStore>()((set) => ({
  ...defaultState,
  fetchMe: async () => {
    const result = await fetchMeService();
    if (result) {
      auth.setUserData(result);
      set({ me: result });
    }
  },
  setMeData: (data) => set((state) => ({ me: { ...state.me, ...(data || {}) } })),
  reset: () => set({ ...defaultState }),
}));

export { useUserStore };
export type { UserStore };
